import { render, staticRenderFns } from "./ReviewCreateModal.vue?vue&type=template&id=58e0f8ed"
import script from "./ReviewCreateModal.vue?vue&type=script&lang=js"
export * from "./ReviewCreateModal.vue?vue&type=script&lang=js"
import style0 from "./ReviewCreateModal.vue?vue&type=style&index=0&id=58e0f8ed&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports